import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import Enum from 'services/enum2';
import IqcService from 'services/iqc';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import ModalService from 'services/modal';
import CommonFns from 'functions/common.ts';
import InquiryService from 'services/inquiry';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

function OpportunityLeadDetail(props) {
  const Config = {
    sale: {
      title: '商机线索详情',
      apiPath: '/opportunityOrder/detail',
      publishApiPath: '/opportunityOrder/publish',
      confirmApiPath: '/opportunityOrder/confirm',
      returnApiPath: '/opportunityOrder/back',
      customerNameKey: 'companyName',
      vendorNameKey: 'customerInnerName',
      arrEnumField: [
        {
          mainKey: 'B02_Opportunity_Status',
          subKey: 'status',
          value: 'statusName'
        },
        { mainKey: 'B_Inq_status', subKey: 'inqStatus', value: 'inqStatusName' }
      ],
      idField: 'oppXkNo',
      wfmCode: '1006'
    }
  };

  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setError,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });
  const [oppStatusItems, setOppStatusItems] = useState([]);

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  //处理详情数据
  self.afterGetDetail = async function (data) {
    if (data.status === 1) {
      // 发布后
      await getProdPageList(data);
    } else {
      data.opportunityOrderProductList.forEach(val => {
        //物料特征码
        if (Array.isArray(val.compProdFeatureList)) {
          val.compProdFeatureStr = val.compProdFeatureList
            .filter(row => row.specShow === 1)
            .map(row => row.featureName)
            .join();
        }
      });
      data.opportunityOrderProductList.forEach(item => {
        if ((data.status === 1 || data.status === 3) && !item.id) {
          item.isEditChange = true;
        }
      });
    }

    let postbody = {
      companyCode: companyCode,
      mainKey: 'B2b_Opp_Status_Code',
      orderProperty: 'subKey',
      apiPath: '/archives/compEnum/list'
    };
    let arr = [];
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        arr = response.data || [];
        arr.unshift({
          subKey: '',
          subValue: '-- 请选择 --'
        });
        arr = arr.map(item => {
          return {
            id: item.subKey,
            text: item.subValue,
            selectedFlag: item.selectedFlag
          };
        });
        setOppStatusItems(arr);
      }
    });
    setDetail(data);
  };

  //获取成本信息列表
  async function getProdPageList(detailData) {
    let postbody = {
      apiPath: '/opportunityOrder/getProdPageList',
      companyCode: companyCode,
      productionCode: detailData.productionCode,
      status: detailData.status,
      pageSize: 100,
      pageNum: 1,
      oppXkNo: self.id
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        let list = data.list || [];
        list.forEach(val => {
          //物料特征码
          if (Array.isArray(val.compProdFeatureList)) {
            val.compProdFeatureStr = val.compProdFeatureList
              .filter(row => row.specShow === 1)
              .map(row => row.featureName)
              .join();
          }
        });
        detailData.opportunityOrderProductList = list;
      }
    });
  }

  // 商机状态下拉选单改变
  function handleOppStatusChange(event) {
    let data = oppStatusItems.filter(item => item.id === event.target.value);
    let ok = () => {
      let postbody = {
        oppXkNo: self.id,
        companyCode: companyCode,
        oppStatusCode: data[0].id,
        oppStatusName: data[0].id ? data[0].text : undefined,
        selectedFlag: data[0].selectedFlag,
        apiPath: '/opportunityOrder/updateOppStatus'
      };
      Http.post('/api/cloudCenter', postbody).then(response => {
        if (response.success) {
          ModalService.showTip('操作成功', dispatch);
          self.getDetail();
        } else {
          ModalService.showError(response.errorMsg, dispatch);
        }
      });
    };

    if (data[0].selectedFlag === 1) {
      ModalService.showConfirm(
        '选择商机' + data[0].text + '后，商机状态将不可修改',
        ok,
        dispatch
      );
    } else {
      ok();
    }
  }

  //发布
  function publish() {
    let postbody = getPostbody(config.publishApiPath);
    InquiryService.publishOppOrder(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //确认
  function handleConfirm() {
    let postbody = getPostbody(config.confirmApiPath);
    InquiryService.ConfirmOppOrder(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //退回
  function handleReturn() {
    let postbody = getPostbody(config.returnApiPath);
    InquiryService.returnOppOrder(
      postbody,
      () => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = { oppXkNo: self.id, companyCode: companyCode, apiPath };
    return postbody;
  }
  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="pb50">
        <div className="order-detail-block">
          <div className="order-detail-title">
            <label>基础信息</label>
          </div>
          <ul>
            {!self.isPurchase && (
              <li>
                <label className="order-detail-label">客户名称</label>
                <div className="order-detail-value">
                  {detail[config.vendorNameKey]}
                </div>
              </li>
            )}
            <li>
              <label className="order-detail-label">商机单号</label>
              <div className="order-detail-value">{detail.oppInnerNo}</div>
            </li>
            <li>
              <label className="order-detail-label">商机名称</label>
              <div className="order-detail-value">{detail.oppTitle}</div>
            </li>
            <li>
              <label className="order-detail-label">状态</label>
              <div
                className={
                  'u-sign ' +
                  CommonFns.getStatusClass('oppOrder', detail.status)
                }
              >
                {detail.statusName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">询价单状态</label>
              <div
                className={
                  'u-sign ' +
                  CommonFns.getStatusClass('oppInq', detail.inqStatus)
                }
              >
                {detail.inqStatusName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">商机状态</label>
              <div className="order-detail-value">
                {(detail.productionCode === companyCode ||
                  detail.status === 0) &&
                detail.selectedFlag !== 1 ? (
                  <Select
                    value={detail.oppStatusCode || ''}
                    onChange={event => handleOppStatusChange(event)}
                    className="select-company-list"
                  >
                    {!Util.isEmpty(oppStatusItems) &&
                      oppStatusItems.map((item, index) => (
                        <MenuItem key={index} value={item.id} name={item}>
                          {item.text}
                        </MenuItem>
                      ))}
                  </Select>
                ) : (
                  <span>{detail.oppStatusName}</span>
                )}
              </div>
            </li>

            {/* 审批流状态 仅开启后才显示 */}
            {updateTs > 0 && workflow.isActive && (
              <li>
                <label className="order-detail-label">审批环节</label>
                <div className="order-detail-value">
                  <WorkflowStatus
                    companyCode={companyCode}
                    id={self.id}
                    workflow={workflow}
                    detail={detail}
                  />
                </div>
              </li>
            )}
            {/* 审批流按钮 */}
            {updateTs > 0 && workflow.isActive && (
              <li>
                <label className="order-detail-label">审批操作</label>
                <div className="order-detail-value">
                  <WorkflowButtons
                    companyCode={companyCode}
                    id={self.id}
                    workflow={workflow}
                    detail={detail}
                    onChange={() => {
                      self.getDetail();
                    }}
                  />
                </div>
              </li>
            )}
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">发布时间</label>
              <div className="order-detail-value">
                {formatDate(detail.publishTime, 'YYYY-MM-DD HH:mm')}
              </div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">发布人</label>
              <div className="order-detail-value">{detail.publishName}</div>
            </li>
          </ul>
          <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div>
        </div>

        {/*检验单单明细 */}
        {!Util.isEmpty(detail.opportunityOrderProductList) && (
          <div className="order-detail-box">
            <div className="order-detail-block">
              <div
                className={
                  !boxState[1]
                    ? 'order-detail-title m-more'
                    : 'order-detail-title m-more m-more-open'
                }
              >
                <label>成本信息</label>
              </div>
              {
                <div className="order-detail-list">
                  <ul>
                    {!Util.isEmpty(detail.opportunityOrderProductList) &&
                      detail.opportunityOrderProductList.map((item, index) => (
                        <li className="order-detail-item" key={index}>
                          <span className="lineNo">项次 {item.lineNo}</span>
                          <ul className="clearfix">
                            <li>
                              物料编码：
                              {item.productCode}
                            </li>
                            <li>
                              物料名称：
                              {item.productName}
                            </li>
                            <li className="single">
                              物料规格：
                              <span>{item.productScale}</span>
                            </li>
                            <li>
                              单位：
                              {item.unitName}
                            </li>
                            <li>
                              需求数量：
                              {formatNumber(
                                item.demandQty,
                                decimalPlace.Quantity_Decimal_Place
                              )}
                            </li>
                            <li>
                              单位用量：
                              {formatNumber(
                                item.unitDosage,
                                decimalPlace.Quantity_Decimal_Place
                              )}
                            </li>
                          </ul>
                        </li>
                      ))}
                  </ul>
                </div>
              }
            </div>
          </div>
        )}
      </div>
      {detail.selectedFlag !== 1 && (
        <div>
          <div className="wrap m-flex-box fixed-bottom">
            {User.checkAuth('20080203') && [0].includes(detail.status) && (
              <Button
                type="default"
                onClick={() => {
                  publish();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发布
              </Button>
            )}
            {User.checkAuth('20080210') &&
              detail.status === 3 &&
              detail.productionCode === companyCode && (
                <Button
                  type="default"
                  onClick={() => {
                    handleReturn();
                  }}
                  className="m-flex-item u-btn u-btn_warn"
                >
                  退回
                </Button>
              )}
            {User.checkAuth('20080207') &&
              detail.status === 3 &&
              detail.productionCode === companyCode &&
              workflow.data &&
              workflow.data['oppo_trans_1'].complete && (
                <Button
                  type="default"
                  onClick={() => {
                    handleConfirm();
                  }}
                  className="m-flex-item u-btn u-btn_primary"
                >
                  确认
                </Button>
              )}
          </div>
        </div>
      )}
      <Modal></Modal>
    </div>
  );
}

OpportunityLeadDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OpportunityLeadDetail);
